// src/utils/menu/accessController.ts

import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { menuMapping } from './menuMapping';
import { useMemo } from 'react';

export const useAllowedControllers = (): string[] => {
  const decodedAuthToken = useSelector((state: RootState) => state.auth.decodedAuthToken);
  return useMemo(() => {
    if (!decodedAuthToken || !decodedAuthToken.AllowedController) return [];
    return Array.from(
      new Set(
        decodedAuthToken.AllowedController.split('|')
          .map((code: string) => menuMapping[code as keyof typeof menuMapping])
          .filter(Boolean)
      )
    );
  }, [decodedAuthToken]);
};

// Function to get the first accessible route
export const getFirstAccessibleRoute = (allowedControllers: string[], routes: string[]): string => {
  let flag = false;
  for (let route of routes) {
    if (allowedControllers.includes(route)) {
      flag = true;
      return route;
    }
  }
  if (!flag) return 'maintenance/access-denied';
  return 'maintenance/500'; // Fallback to a 500 error page if no routes are accessible
};

export const useEnabledMenuIds = (): Set<string> => {
  const decodedAuthToken = useSelector((state: RootState) => state.auth.decodedAuthToken);

  const allowedControllers = useMemo(() => {
    if (!decodedAuthToken || !decodedAuthToken.AllowedController) return [];
    return Array.from(new Set(decodedAuthToken.AllowedController.split('|')));
  }, [decodedAuthToken]);

  return useMemo(() => {
    const enabledMenuIds = new Set<string>();

    allowedControllers.forEach((controller: any) => {
      if (menuMapping[controller]) {
        const menuItem = menuMapping[controller as keyof typeof menuMapping];
        enabledMenuIds.add(menuItem);
      }
    });

    return enabledMenuIds;
  }, [allowedControllers]);
};
